import { render } from "./GameResultPreview.vue?vue&type=template&id=eef4f522&scoped=true"
import script from "./GameResultPreview.vue?vue&type=script&lang=js"
export * from "./GameResultPreview.vue?vue&type=script&lang=js"

import "./GameResultPreview.vue?vue&type=style&index=0&id=eef4f522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef4f522"]])

export default __exports__